/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Due_Payments_TitleInputs */

const en_due_payments_title = /** @type {(inputs: Due_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To pay`)
};

const pl_due_payments_title = /** @type {(inputs: Due_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do zapłaty`)
};

/**
* | output |
* | --- |
* | "To pay" |
*
* @param {Due_Payments_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const due_payments_title = /** @type {((inputs?: Due_Payments_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_Payments_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_due_payments_title(inputs)
	return en_due_payments_title(inputs)
});